import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Margin, Panel, Text, Table } from 'shared/components'
import { EventsFilters } from './components/filters'

const TransHistoryBeneComponent = ({ loadTransHistory, columns, onSearch }) => {
  return (
    <Panel>
      <Grid>
        <Row>
          <Col lg={3} xs={12}>
            <Margin top={1} bottom={2}>
              <Text size={18} bold white>
                Transactions History
              </Text>
            </Margin>
          </Col>
          <Col lg={9} xs={12}>
            <EventsFilters debounce={250} onSearch={onSearch} />
          </Col>
        </Row>
      </Grid>
      <Table
        id="transHistorySponsor-table"
        columns={columns}
        loadData={loadTransHistory}
      />
    </Panel>
  )
}

TransHistoryBeneComponent.propTypes = {
  loadTransHistory: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape()),
  onSearch: PropTypes.func.isRequired,
}

export default TransHistoryBeneComponent
